<div class="tabs__wrapper" *ngIf="tabList.length">
  <div class="tabs__item" *ngFor="let tab of tabList">
    <span class="tabs__btn" [ngClass]="{'active': activeTab  === tab}" (click)="setTab(tab)">
      {{'app.tabs.' + tab | translate}}
    </span>
  </div>
</div>
